export class Service {
	public start() {}
}
